import {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectDetails} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {AddButtonWithTitle} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/AddButtonWithTitle/AddButtonWithTitle';
import {CohostOverlay} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Cohost/CohostOverlay';
import {Divider} from '~library/atoms/Divider';
import {InputWithRemove} from '../InputWithRemove/InputWithRemove';
import {Section} from '../Section/Section';

export const Cohost = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const dispatch = useDispatch();
  const {cohost} = useSelector(selectDetails);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const openOverlay = useCallback(() => {
    setShowOverlay(true);
  }, [setShowOverlay]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const closeOverlay = useCallback(() => {
    setShowOverlay(false);
  }, [setShowOverlay]);

  const [showCoHost, setShowCoHost] = useState(false);

  const [overlayError, setOverlayError] = useState('');

  useEffect(() => {
    setShowCoHost(Boolean(cohost?.name && cohost?.email));
  }, [cohost]);

  const onRemoveClickHandler = () => {
    setShowCoHost(false);
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {
        cohost: {name: '', email: ''},
        // biome-ignore lint/style/useNamingConvention: existing error
        host_ids: [window.user_id],
        // biome-ignore lint/style/useNamingConvention: existing error
        pending_host_ids: [],
      },
    });
  };

  return (
    <>
      <CohostOverlay
        isOpen={showOverlay}
        closeOverlay={closeOverlay}
        overlayError={overlayError}
        setOverlayError={setOverlayError}
      />
      <Divider />

      {showCoHost && (
        <Section title="CO-HOSTED BY">
          <InputWithRemove
            name="cohost"
            dataQaId="event-cohost"
            type="text"
            value={cohost.name}
            onClick={openOverlay}
            onRemove={onRemoveClickHandler}
            fullWidth
          />
        </Section>
      )}

      {!showCoHost && (
        <AddButtonWithTitle label="Co-Host" dataQaId="add-eventcohost" onClick={openOverlay} />
      )}
    </>
  );
};
